/**
 * The call-to-action labels an author can put on a Demand Gen single-image ad.
 *
 * These strings ARE the stored value, not keys: the block persists the label
 * verbatim under `Text`, which is what the previews and the docx export read.
 * Rewording a row therefore orphans the CTA of every template that already
 * saved the old wording — add a row instead of editing one.
 */
export const CTA_TEXTS: readonly string[] = [
  'Prijavite se sada',
  'Rezervirajte sada',
  'Kontaktirajte nas',
  'Preuzmite',
  'Saznajte više',
  'Posjetite web stranicu',
  'Kupite odmah',
  'Prijavite se',
  'Dobiti ponudu',
  'Pretplati se',
  'Vidi više',
];

/**
 * The call-to-action labels for a Demand Gen video ad.
 *
 * Kept separate from {@link CTA_TEXTS}: video ads use Google's English label
 * set, and the two lists must be free to drift. Same contract as above — the
 * label IS the stored value, so add a row instead of rewording one.
 */
export const GEN_VIDEO_CTA_TEXTS: readonly string[] = [
  'Get quote',
  'Install',
  'Learn more',
  'Order now',
  'Play now',
  'Shop now',
  'Sign up',
  'Start now',
  'Subscribe',
  'Visit site',
  'Watch now',
  'Apply now',
  'Book now',
  'See more',
  'Buy now',
  'Contact us',
  'Donate now',
  'Download',
];
